import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

const useStyles = makeStyles((theme) => ({
  cssCard: {
    textAlign: "center",
  },
  cargandoComp: {
    textAlign: "center",
  },
}));

const stylesCss = {
  root: {
    "& .MuiStepIcon-root.Mui-active": { color: "red" },
    "& .MuiStepIcon-root.Mui-completed": { color: "#FF0000" },
    "& .Mui-disabled .MuiStepIcon-root": { color: "#ffcdd2" },
  },
  card: {
    textAlign: "center",
  },
  btnBuscarRegresar: {
    backgroundColor: "red",
    borderRadius: "13px",
    height: "60px",
    padding: "15px 30px 15px 30px",
    "&:hover": {
      backgroundColor: "#ffcdd2",
      opacity: [0.9, 0.8, 0.7],
      color: "black",
    },
  },
  btnNoEmpresa: {
    backgroundColor: "rgb(121, 117, 117)",
    borderRadius: "13px",
    textAlign: "center",
    width: "200px",
    padding: "15px 30px 15px 30px",
  },
  gridBtnRegresar: {
    textAlign: "right",
  },
  gridBtnContinuar: {
    textAlign: "left",
  },
};

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "black",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "green",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "gray",
    },
    "&:hover fieldset": {
      borderColor: "gray",
    },
    "&.Mui-focused fieldset": {
      borderColor: "gray",
    },
  },
});
const Container = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    padding: "8px",
  },
}));
const Column = styled("div")(({ theme }) => ({
  //   margin: "auto",
  marginBottom: "30px",
  borderRadius: "20px",
  padding: "15px",
  width: "100%",
  maxWidth: "50%",
  [theme.breakpoints.down("md")]: {
    maxWidth: "100%",
    margin: "auto",
  },
}));
const Button = styled("button")((props) => ({
  width: "100%",
  backgroundColor: "#FF0000",
  textAlign: "center",
  padding: "15px",
  borderRadius: "15px",
  border: "0px",
  color: "white",
  maxWidth: "25rem",
  "&:hover": {
    backgroundColor: "#ffcdd2",
    opacity: [0.9, 0.8, 0.7],
    color: "black",
  },
  "&:focus": {
    outline: "0 !important",
  },
}));
const FilterButton = styled(Button)(({ theme }) => ({
  marginTop: "5px",
  width: "15%",
  backgroundColor: "#80808000",
  color: "#808080",
  [theme.breakpoints.down("sm")]: {
    width: "40%",
  },
  "&:hover": {
    backgroundColor: "#808080",
    opacity: [0.9, 0.8, 0.7],
    color: "white",
  },
}));
const ButtonDeliveryDate = styled(Button)(({ theme }) => ({
  marginTop: "1px",
  padding: "10px",
  width: "100%",
  backgroundColor: "#80808000",
  color: "#808080",
  // [theme.breakpoints.down("sm")]: {
  //   width: "100%",
  // },
  "&:hover": {
    backgroundColor: "#ffc2bf",
    opacity: [0.9, 0.8, 0.7],
    color: "black",
  },
}));

const SearchButton = styled(Button)(({ theme }) => ({
  marginTop: "5px",
  width: "80%",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));
const OneColumn = styled("div")(({ theme }) => ({
  margin: "auto",
  marginBottom: "30px",
  borderRadius: "20px",
  textAlign: "center",
  padding: "15px",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    maxWidth: "100%",
  },
}));
const FourColumn = styled(OneColumn)(({ theme }) => ({
  width: "23%",
  padding: "0px",
  minHeight: "90px",
  marginBottom: "0px",
  [theme.breakpoints.down("lg")]: {
    width: "90%",
    maxWidth: "100%",
  },
}));
const H3 = styled("h3")(({ theme }) => ({
  padding: "35px",
  color: "gray",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    padding: "20px",
  },
}));
export {
  CssTextField,
  Container,
  Column,
  Button,
  OneColumn,
  FilterButton,
  FourColumn,
  SearchButton,
  ButtonDeliveryDate,
  H3,
};
export default stylesCss;
export { useStyles };
